import { FusionTradeInButtonContainer } from '../../../components/common/tradeIn-button/fusion-tradeIn-button-container';
import AstuteAccordion from '../astute-accordion/astute-accordion';
import React, { useContext } from 'react';
import { PrimaryButton } from '../../../components/common';
import { useAnalytics } from '../../../hooks/use-analytics';
import { BrandUtil } from '../../../components/utils/brand-util/brand-util';
import ServerContext from '../../../contexts/serverContext';

interface Props {
    astuteTopicDiv: Element | null | undefined;
    accordions: Element[] | null | undefined;
    topicResponse: any;
}

const AstuteTopicTeslaCharger = (props: Props) => {
    const serverContext = useContext(ServerContext);
    const [fireEvents] = useAnalytics();
    const buttonCodeToReplace = `<a href="https://www.ford.com/myaccount/account-dashboard?connectedservices=true" target="_blank"><img style="aspect-ratio:1179/120;" src="https://ak-content-us-east-public.s3.amazonaws.com/0d5efd6a-ec24-4fcc-bd94-235da25f19fe" alt="Clickable button that states Reserve your Fast Charging Adapter" width="450" height="42"></a>`;
    //temp tesla stuff starts
    const { isFord } = new BrandUtil();
    const langReg: string = serverContext.currentLanguageRegionCode || '';
    const topicId = props.topicResponse?.data?.topicId?.toString() || '';

    const isTeslaCharger =
        props.topicResponse?.data?.topicId?.toString() == '1028373714' &&
        isFord &&
        langReg.toLowerCase() === 'en-us';

    const isFocusTradeIn =
        props.topicResponse?.data?.topicId?.toString() == '1026505365' &&
        isFord &&
        langReg.toLowerCase() === 'en-us';

    const buttonWithAnalytics = () => {
        return (
            <div className="reserve-charger-article-button-container">
                <PrimaryButton
                    className="reserve-charger-article-button"
                    fill={'fill'}
                    color={'dark'}
                    chevron={true}
                    href="https://www.ford.com/myaccount/account-dashboard?connectedservices=true&_gl=1*1pftede*_gcl_au*MTQ4NjE4NDQ4Ny4xNzEwMTcwNzQ3"
                    onClick={() => {
                        fireEvents(
                            'fast-charging-adapter-article',
                            undefined,
                            undefined,
                            false
                        );
                    }}
                >
                    Reserve your Fast Charging Adapter
                </PrimaryButton>
            </div>
        );
    };

    const teslaChargerReplace = (div: string, accordionsArray: Element[]) => {
        const buttonSplit =
            div.includes(buttonCodeToReplace) &&
            div?.split(buttonCodeToReplace);

        return (
            <>
                {buttonSplit && buttonSplit.length > 1 ? (
                    <>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: buttonSplit[0],
                            }}
                        />
                        {buttonWithAnalytics()}
                        {
                            <AstuteAccordion
                                topic={buttonSplit[1]}
                                accordions={accordionsArray}
                                eventName={'accordion-click'}
                                category={
                                    props.topicResponse?.data?.categoryName ||
                                    ''
                                }
                                subcategory={
                                    props.topicResponse?.data
                                        ?.subCategoryName || ''
                                }
                                topicId={topicId}
                            />
                        }
                    </>
                ) : (
                    <AstuteAccordion
                        topic={div}
                        accordions={accordionsArray}
                        eventName={'accordion-click'}
                        category={props.topicResponse?.data?.categoryName || ''}
                        subcategory={
                            props.topicResponse?.data?.subCategoryName || ''
                        }
                        topicId={topicId}
                    />
                )}
            </>
        );
    };
    //temp tesla stuff ends

    return (
        <>
            {props.astuteTopicDiv &&
                props.accordions &&
                !isTeslaCharger &&
                isFocusTradeIn &&
                props.accordions?.length > 0 && (
                    <FusionTradeInButtonContainer
                        topicResponse={props.topicResponse}
                        astuteTopicDiv={props.astuteTopicDiv}
                        accordions={props.accordions}
                        isFocusTradeIn={isFocusTradeIn}
                        isTeslaCharger={isTeslaCharger}
                    />
                )}
            {props.astuteTopicDiv &&
                props.accordions &&
                !isFocusTradeIn &&
                props.accordions.length > 0 && (
                    <>
                        {isTeslaCharger ? (
                            <>
                                {teslaChargerReplace(
                                    props.astuteTopicDiv.innerHTML,
                                    props.accordions
                                )}
                            </>
                        ) : (
                            <AstuteAccordion
                                topic={props.astuteTopicDiv.innerHTML}
                                accordions={props.accordions}
                                eventName={'accordion-click'}
                                category={
                                    props.topicResponse?.data?.categoryName ||
                                    ''
                                }
                                subcategory={
                                    props.topicResponse?.data
                                        ?.subCategoryName || ''
                                }
                                topicId={topicId}
                            />
                        )}
                    </>
                )}
        </>
    );
};

export default AstuteTopicTeslaCharger;
